import { defineMessages } from 'react-intl';

export default defineMessages({
    quote: {
        id: 'quoteandbind.ConsTraAndServProduct.directives.templates.qnb-info-bar.Lob Insurance Quote',
        defaultMessage: 'Quote',
    },
    location: {
        id: 'quoteandbind.ConsTraAndServProduct.directives.templates.qnb-info-bar.Lob Location',
        defaultMessage: 'Location',
    },
    // add string ids and default values for localization here
});
